// FormattedDate.jsx
import { useContext } from "react";
import { UserContext } from "../Context/UserContext";
import { formatGameDate } from "../utils/formatGameDate";

function FormattedDate() {
    const { state } = useContext(UserContext);
    return <>{formatGameDate(state?.games)}</>;
}

export default FormattedDate;